import axios from 'axios';
import { environment } from '../../../src/environments/environment';

const sendEmail = async (formData) => {
  const path = environment.api + environment.sendSupport;
  const config = {
    headers: {
      'Content-Type': 'application/json',
    },
  };
  const body = JSON.stringify({
    email: formData.email,
    reemail: "soporte.3bio@bios.co",
    subject: formData.subject,
    message: buildMessage(formData)
    })

   
  return await axios.post(path, body, config);
};
const buildMessage = (formData) => {
  let message = `<strong>Solicitud de soporte</strong><br>`;

  // Campos obligatorios
  message += `<strong>Nombre:</strong> ${formData.name}<br>`;
  message += `<strong>Correo:</strong> ${formData.email}<br>`;
  message += `<strong>Asunto:</strong> ${formData.subject}<br>`;

  // Campos opcionales
  if (formData.lastName) {
    message += `<strong>Apellido:</strong> ${formData.lastName}<br>`;
  }
  if (formData.phone) {
    message += `<strong>Teléfono:</strong> ${formData.phone}<br>`;
  }
  if (formData.entidad) {
    message += `<strong>Entidad:</strong> ${formData.entidad}<br>`;
  }
  if (formData.component) {
    message += `<strong>Módulo con inconvenientes:</strong> ${formData.component}<br>`;
  }
  if (formData.description) {
    message += `<strong>Descripción:</strong> ${formData.description}<br>`;
  }

  return message;
};


export { sendEmail };